import React from 'react';
import {
  FDBox,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { advisorPage } from 'Consts/Strings';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const HouseholdSectionServiceLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDBox>
      <FDStack direction={'row'} justifyContent={'center'}>
        <FDTextButton
          label={resource?.relationship(fr.relationships.billingDetailsPage.name).meta('prompt') || 'Billing Details'}
          href={buildPageLink(
            resource?.relationship(fr.relationships.billingDetailsPage.name).link('related'),
            advisorPage,
          )}
        />
      </FDStack>
    </FDBox>
  );
};

HouseholdSectionServiceLayout.propTypes = {
};

export default HouseholdSectionServiceLayout;
